/**
 * Routes where the Apex bubble + drawer must not appear:
 *  - sign-in / request-access: pre-auth pages
 *  - /agency, /vendor: public intake forms (anonymous users)
 *
 * Both ApexBubble (entry point) and ApexProvider (drawer state) consult
 * this set so a drawer left open on Dashboard auto-closes when the user
 * navigates to a public route.
 */
export const APEX_HIDDEN_PATHS: ReadonlySet<string> = new Set([
  "/signin",
  "/request-access",
  "/agency",
  "/vendor",
]);

export function isApexHiddenPath(pathname: string): boolean {
  return APEX_HIDDEN_PATHS.has(pathname);
}
